var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 164,
    fill: "none",
    viewBox: "0 0 199 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.329,
    height: 16.942,
    x: 33.885,
    y: 149.013,
    fill: "#FFE6E6",
    rx: 8.471,
    transform: "rotate(-30 33.885 149.013)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.565,
    height: 16.924,
    x: 11.066,
    y: 103.474,
    fill: "#FFE6E6",
    rx: 8.462,
    transform: "rotate(-30 11.066 103.474)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.942,
    height: 16.942,
    x: 141.77,
    y: 8.471,
    fill: "#FFE6E6",
    rx: 8.471,
    transform: "rotate(-30 141.77 8.471)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6E6",
    fillRule: "evenodd",
    d: "M43.094 65.442a8.471 8.471 0 008.46 14.679l26.053-15.042a8.471 8.471 0 118.471 14.673L57.122 96.47l-.026.014-7.165 4.137a8.471 8.471 0 00-3.1 11.572 8.471 8.471 0 0011.571 3.101l104.36-60.252a8.471 8.471 0 00-8.446-14.688l-22.18 12.806a8.472 8.472 0 01-8.471-14.673l6.23-3.596a8.472 8.472 0 00-8.482-14.667L43.094 65.442zm41.762 34.579a8.471 8.471 0 018.448 14.686l-11.391 6.577.022-.013 10.494-6.059a8.471 8.471 0 108.471 14.672l62.869-36.297a8.471 8.471 0 10-8.471-14.672l-20.892 12.061a8.83 8.83 0 00.336-.204 8.472 8.472 0 01-8.463-14.657c-.115.06-.23.123-.344.189l-41.08 23.717z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.922,
    cy: 99.85,
    r: 4.15,
    stroke: "#FFE5E5",
    strokeWidth: 2.605
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.343,
    cy: 43.625,
    r: 3.022,
    stroke: "#FFE5E5",
    strokeWidth: 2.605
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.456,
    cy: 150.809,
    r: 3.022,
    stroke: "#FFE5E5",
    strokeWidth: 2.605
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.53,
    height: 1.88,
    x: 120.533,
    y: 4.325,
    fill: "#FFE6E6",
    rx: 0.94
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.53,
    height: 1.88,
    x: 126.738,
    y: 0,
    fill: "#FFE6E6",
    rx: 0.94,
    transform: "rotate(90 126.738 0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 157.014,
    y: 125.329,
    fill: "#FFE6E6",
    rx: 0.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 161.902,
    y: 122.414,
    fill: "#FFE6E6",
    rx: 0.94,
    transform: "rotate(90 161.902 122.414)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 7.146,
    y: 87.157,
    fill: "#FFE6E6",
    rx: 0.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7.898,
    height: 1.88,
    x: 12.035,
    y: 84.242,
    fill: "#FFE6E6",
    rx: 0.94,
    transform: "rotate(90 12.035 84.242)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.529,
    cy: 81.812,
    r: 40.385,
    fill: "#fff",
    stroke: "#F33",
    strokeWidth: 2.605
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 79,
    height: 79,
    x: 60,
    y: 42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.529,
    cy: 81.812,
    r: 39.082,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC4C4",
    d: "M99.529 39.343H142.78V123.239H99.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F33",
    d: "M102.839 89.104h-6.31V62.792h6.31v26.312zm-3.18 4.337c1.144 0 2.103.344 2.877 1.034.774.723 1.161 1.61 1.161 2.661s-.387 1.922-1.161 2.612c-.774.722-1.733 1.084-2.877 1.084-1.144 0-2.104-.345-2.878-1.035-.774-.657-1.16-1.495-1.16-2.513 0-1.084.386-2.004 1.16-2.76.74-.722 1.7-1.084 2.878-1.084z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.89875e7f.svg";
export { ForwardRef as ReactComponent };